import React, { useEffect, useState } from 'react'
import style from './GraphHeader.module.css'
import renderPrgImage from '../../../source/programImg'
import { useHistory } from 'react-router'
import {
    deviceDetails,
    deviceMismatch,
    showModal,
    webSerialConnect,
} from '../../../redux/actions'
import { connect } from 'react-redux'
import {
    connectSerialDevice,
    connectSerialDeviceIntermediate,
    connectUSBDevice,
} from '../../WebSerialConnection/SerialUSBConnect'
import DialogModal from '../DialogModal/DialogModal'
import BatteryIndicator from '../ZingNotifications/BatteryIndicator'
import DeviceMissMatchPopupCom from './DeviceMissMatchPopupCom'

function GraphHeader({
    isGoBack,
    goBack,
    text,
    helpBtn1,
    helpBtn,
    webSerial,
    showGraph,
    webSerialConnect,
    showModal,
    setConnectedPort,
    device,
    deviceMismatch,
    deviceDetail,
    showFirmwareUpdateDialog,
}) {
    const [isDeviceMismatch, setIsDeviceMismatch] = useState(false)
    const connectedDevice = sessionStorage.getItem('connectedDevice')
    const deviceVersion = sessionStorage.getItem('deviceVersion')
    const history = useHistory()
    const [showErrorMsg, setshowErrorMsg] = useState(false)

    let deviceName = ''
    switch (connectedDevice) {
        case 'Hexapod':
            deviceName = 'Crawl-e'
            break
        default:
            deviceName = 'Zing'
    }

    const handleUSB = async () => {
        if (!webSerial.isConnected) {
            let res = null
            if (sessionStorage.getItem('deviceVersion')?.startsWith('1')) {
                res = await connectUSBDevice({ isAutomatic: false })
            } else
                res = await connectSerialDeviceIntermediate({
                    isAutomatic: false,
                })

            if (res !== undefined) {
                if (res.matchedObj_with_Version?.firmwareUnsupported) {
                    // Unsupported firmware must never be accepted as the
                    // connected device — show the firmware update dialog
                    // directly instead of the generic device-mismatch popup.
                    const mismatchedDevice = res.matchedObj_with_Version
                    showFirmwareUpdateDialog({
                        currentVersion: mismatchedDevice.currentVersion,
                        latestVersion: mismatchedDevice.minFirmware,
                        deviceName: mismatchedDevice.id,
                        firmwareCheck: { mandatory: true },
                    })
                } else if (!res.isPortOpen) {
                    deviceMismatch({
                        deviceMismatched: res.matchedObj_with_Version,
                        isMemoryPresent: res.isMemoryPresent,
                        isArmError: res.isArmError,
                        is2In1Sensor: res.is2In1Sensor,
                        plodeNativeData: {
                            ...device.plodeNativeData,
                            mountPoint: res.mountPoint,
                        },
                    })
                    setIsDeviceMismatch(true)
                } else {
                    setIsDeviceMismatch(false)
                    deviceMismatch({
                        deviceMismatched: {},
                        isMemoryPresent: res.isMemoryPresent,
                        isArmError: res.isArmError,
                        is2In1Sensor: res.is2In1Sensor,
                        plodeNativeData: {
                            ...device.plodeNativeData,
                            mountPoint: res.mountPoint,
                        },
                    })
                }
            }
            if (res.isPortOpen) {
                webSerialConnect({ port: res.port })
                setConnectedPort(res.port)
            } else setshowErrorMsg(true)
        }
    }
    const handleDevice = async (option) => {
        if (option === 'no') {
            let port = webSerial.port
            //is this needed??
            // await openSerialReadComPort(port,worker)
        } else if (device.deviceMismatched?.firmwareUnsupported) {
            // Unsupported firmware must never be accepted as the connected
            // device — send the user back to the scan flow to update it.
            history.push('/Selection')
        } else {
            history.push('/Selection')
            let mismatchedDevice = device.deviceMismatched
            sessionStorage.setItem('connectedDevice', mismatchedDevice.id)
            // if (mismatchedDevice.id === 'Ace') {
            sessionStorage.setItem('deviceVersion', mismatchedDevice.version)
            if (webSerial.isConnected)
                sessionStorage.setItem('isDeviceConnected', true)
            deviceDetail({
                connectedDevice: mismatchedDevice.id,
                deviceVersion: mismatchedDevice.version,
            })
            // } else {
            //     sessionStorage.setItem('zingVersion', mismatchedDevice.version)
            //     deviceDetail({
            //         connectedDevice: mismatchedDevice.id,
            //         zingVersion: mismatchedDevice.version,
            //         deviceVersion: '0.0.0',
            //     })
            // }
        }
        setIsDeviceMismatch(false)
        deviceMismatch({ deviceMismatched: {} })
    }

    //when device is disconnect set the mismatch empty
    useEffect(() => {
        if (sessionStorage.getItem('isDeviceConnected') == 'false') {
            setIsDeviceMismatch(false)
            deviceMismatch({ deviceMismatched: {} })
        }
    }, [webSerial.isConnected])

    //handle error in connection
    const handleError = async () => {
        setshowErrorMsg(false)
        window.location.reload()
    }
    useEffect(() => {
        if (device) {
            let deviceD = Object.keys(device.deviceMismatched)
            if (deviceD.length > 1) {
                if (isDeviceMismatch == false) {
                    setIsDeviceMismatch(true)
                }
            }
        }
    }, [device.deviceMismatched])
    return (
        <>
            <DialogModal
                mismatchShow={isDeviceMismatch}
                text={<DeviceMissMatchPopupCom />}
                showCloseBtn={true}
                handleDialogModalClose={() => setIsDeviceMismatch(false)}
                optionsToSelect={[
                    {
                        text: 'YES',
                        do: () => handleDevice('yes'),
                    },
                    // {
                    //     text: 'NO',
                    //     do: () => handleDevice('no'),
                    // },
                ]}
            />
            {/* Old memory-card dialog for Zing: replaced by the firmware SD-card
                notification (ZingNotificationHost). */}
            {/*
            <DialogModal
                mismatchShow={
                    connectedDevice == 'Humanoid' &&
                    parseInt(deviceVersion?.split('.')?.[0] || '0') >= 2 &&
                    webSerial.isConnected &&
                    !isDeviceMismatch &&
                    !device.isMemoryPresent
                }
                text={
                    !device.isMemoryPresent
                        ? `There is no memory card inserted in ${deviceName}. \nkindly insert one to use the application further.`
                        : ''
                }
                showCloseBtn={false}
                optionsToSelect={[
                    {
                        text: 'YES',
                        do: () => history.push('/kitSelection'),
                    },
                ]}
            />
            */}
            <DialogModal
                showError={showErrorMsg}
                text={
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <p
                            style={{
                                transform: 'translateY(20%)',
                                fontSize: '2.5vh',
                            }}
                        >
                            Error in connecting the device!
                        </p>
                        <p
                            style={{
                                transform: 'translateY(20%)',
                                fontSize: '2vh',
                            }}
                        >
                            Please disconnect the device and try connecting
                            again.
                        </p>
                    </div>
                }
                showCloseBtn={true}
                handleDialogModalClose={() => setshowErrorMsg(false)}
                optionsToSelect={[
                    {
                        text: 'OK',
                        do: handleError,
                    },
                ]}
            />
            <div className={style.Main_Header}>
                <div id={style.firstDiv} style={{ position: 'relative' }}>
                    {isGoBack ? (
                        <img
                            className={style.backBtn}
                            src={renderPrgImage('backBtn')}
                            onClick={() => {
                                if (goBack) goBack()
                                else history.goBack()
                            }}
                        ></img>
                    ) : null}
                </div>
                <div id={style.SecondDiv} style={{ position: 'relative' }}>
                    <p className={style.text}> {text} </p>
                </div>

                <div id={style.ThirdDiv}></div>

                <div id={style.ForthDiv}>
                    {showGraph && (
                        <img
                            className={style.graphBtn}
                            src={renderPrgImage('graphbtn')}
                        ></img>
                    )}

                    {helpBtn && (
                        <img
                            className={style.helpBtn}
                            src={renderPrgImage('graphHelpBtn')}
                        ></img>
                    )}

                    {helpBtn1 && (
                        <img
                            className={style.helpBtn1}
                            src={renderPrgImage('graphHelpBtn')}
                        ></img>
                    )}

                    {/* {webSerial && (
                        <img
                            className={style.bluetooth}
                            src={renderPrgImage('connectionOn')}
                        />
                    )} */}

                    {webSerial.isConnected ? (
                        <span
                            style={{
                                position: 'relative',
                                display: 'inline-block',
                                lineHeight: 0,
                                marginTop: '6.5%',
                            }}
                        >
                            <img
                                src={renderPrgImage('usbON')}
                                onClick={handleUSB}
                                style={{ height: '8vh' }}
                            />
                            <BatteryIndicator />
                        </span>
                    ) : (
                        <img
                            src={renderPrgImage('usbOFF')}
                            onClick={handleUSB}
                            style={{ height: '8vh', marginTop: '6.5%' }}
                        />
                    )}
                </div>
            </div>
        </>
    )
}

const mapStateToProps = (state) => {
    return state
}
const mapDispatchToProps = (dispatch) => {
    return {
        webSerialConnect: (data) => {
            dispatch(webSerialConnect(data))
        },

        showModal: (data) => {
            dispatch(showModal(data))
        },
        deviceMismatch: (data) => {
            dispatch(deviceMismatch(data))
        },
        deviceDetail: (data) => {
            dispatch(deviceDetails(data))
        },
        showFirmwareUpdateDialog: (payload) => {
            dispatch({ type: 'SHOW_FIRMWARE_UPDATE_DIALOG', payload })
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(GraphHeader)
